import React, { useEffect, useCallback, useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// GLOBAL HELPERS
import useRecordView from 'helpers/getRecordView';
import { useRecordContext } from 'helpers/getRecordData';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL FUNCTIONS
import { apiFetch } from 'functions';

// LOCAL COMPONENTS
import Card from 'parts/card/Card';
import Form from 'core/form/Form';

// VARIABLES
const ITEM_CONSTRUCTOR = (obj = {}) =>  ({
  sales_dealer_pack_id: '',
  item_Amount: obj.pack_amount || '',
  item_name: obj.pack_title || '',
  is_admin_pack: obj.is_admin_pack || false,
  item_add_as_task: false
})

// FORM COMPONENT
const DealerPackForm = () => {

  // CONEXT
  const { isAdd } = useRecordView();
  const { values, setFieldValue } = useFormikContext() || {};
  const { loading: recordLoading } = useRecordContext();

  // MEMOS
  const {
    daily_sales_inventory_id,
    sale_type_category_id
  } = useMemo(
    () => values || {},
    [values]
  )

  // CALLBACKS
  const addDealerPacks = useCallback(
    dealerPacks => {
      const value = dealerPacks
        .filter(v => parseInt(v.sale_type_category_id) === parseInt(sale_type_category_id))
        .map(ITEM_CONSTRUCTOR);
      setFieldValue(`aryDealerPack`, value);
    },
    [sale_type_category_id, setFieldValue]
  )

  // EFFECTS
  useEffect(
    () => {
      if (!isAdd || !daily_sales_inventory_id || recordLoading) return; 
      apiFetch({
        method: 'GET',
        endpoint: `${ENDPOINTS.sales.dealerpack}/${daily_sales_inventory_id}`,
        onSuccess: addDealerPacks
      })
    },
    [sale_type_category_id, daily_sales_inventory_id, isAdd, addDealerPacks, recordLoading]
  )

  const handleChange = useCallback((item,i) => {
    if(!isAdd && item.sales_dealer_pack_id !== '' ) {
      setFieldValue(`aryDealerPack[${i}].isUpdated`,true)
    }
   },[setFieldValue, isAdd])

   const handleDelete = useCallback((item,i) => {
    if(!isAdd && item.sales_dealer_pack_id !== '' ) {
      setFieldValue(`aryDealerPack[${i}].isUpdated`, false);
      setFieldValue(`aryDealerPack[${i}].isDeleted`,true)
      return true;
    }
    else return false;

   },[setFieldValue, isAdd])

  // RENDER
  return (
    <Form.Body>
      <Form.Table
        name="aryDealerPack"
        itemLabel="FE Dealer Packs"
        itemConstructor={ITEM_CONSTRUCTOR}
        buttonBefore
        handleDelete={(item,i) => handleDelete(item,i)}
      >{(item = {},i) => [
        <Form.Control
          name="item_Amount"
          label="Amount"
          schema="dollars"
          plaintext={item.is_admin_pack}
          onChange={() => handleChange(item,i)}
          colWidth={6}
          required
          />,
        <Form.Control
          name="item_name"
          label="Description"
          maxLength={100}
          plaintext={item.is_admin_pack}
          onChange={() =>handleChange(item,i)}
          colWidth={12}
          required
          />,
        <Form.YesNo
          name="item_add_as_task"
          text="Add as Task"
          type="checkbox"
          onChange={() =>handleChange(item,i)}
          numeric={false}
          colWidth={6}
        />
      ]}</Form.Table>
    </Form.Body>
  )
}

export default function DealerPack(props) {
  return <Card title="Dealer Pack" body={<DealerPackForm {...props} />} />;
}
